<h1 > {{ GetDescription() }}  {{ GetValueAsString(mValue) }}   <app-unit [unit]="GetUnit()"></app-unit>   </h1>
<kendo-radialgauge class="complexgauge"  [pointer]="{ value: GetPointerValue(), color: 'DarkBlue', length: GetLenght() }"
>
  <kendo-radialgauge-scale [majorUnit]="-1" [min]= "0" [max]="270"
                           [majorTicks]="{ visible: false, color: 'black' }"
                           [minorTicks]="{ visible: false, color: 'red' }"
                           [rangeSize]="15"
  >
   <kendo-radialgauge-scale-ranges>
      <kendo-radialgauge-scale-range [from]="0"   [to]="45"  [color]="alarmColor" >        </kendo-radialgauge-scale-range>
      <kendo-radialgauge-scale-range [from]="45"  [to]="135" color="#cbf1bd">      </kendo-radialgauge-scale-range>
      <kendo-radialgauge-scale-range [from]="135" [to]="225" color="white">      </kendo-radialgauge-scale-range>
      <kendo-radialgauge-scale-range [from]="225" [to]="270" [color]="alarmColor">        </kendo-radialgauge-scale-range>
    </kendo-radialgauge-scale-ranges>
  </kendo-radialgauge-scale>
</kendo-radialgauge>

<h2>Setpoint: {{ GetValueAsString(sValue) }}   <app-unit [unit]="GetUnit()"></app-unit> </h2>

Low:  {{ GetLow() | number: '1.0-1' }} High:   {{ GetHigh() | number: '1.0-1' }} <br/>
Range:  {{ Bottom() | number: '1.0-1' }} /   {{ Top() | number: '1.0-1' }} <br/>


